import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]'
})
export class OnlyNumbersDirective {
  @Input() maxLength: number = Infinity;

  // Manejo del evento keypress para permitir solo números
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    // Permitir solo números (códigos de tecla del 0 al 9)
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // Manejo del evento paste para filtrar caracteres no numéricos
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedInput = event.clipboardData.getData('text/plain');
    const numericValue = pastedInput.replace(/[^0-9]/g, '');
    const finalValue = this.maxLength !== Infinity ? 
      numericValue.substring(0, this.maxLength) : 
      numericValue;
    
    // Usar setTimeout para asegurar que se ejecute después del evento de pegado
    setTimeout(() => {
      document.execCommand('insertText', false, finalValue);
    }, 0);
  }
}


